export default [
  {
    text: "Home",
    path: "/home",
    icon: "home",
    role_id: [1,2,3]
  },
  {
    text: 'Rekapitulasi',
    path: '/dashboard-page',
    icon: 'exportxlsx',
    role_id: [1,3]
  }, 
  {
    text: 'Pemakaian Nol',
    path: '/pemakaian-nol-page',
    icon: 'fill',
    role_id: [1,3]
  }, 
  {
    text: 'User Management',
    path: '/user-management-page',
    icon: 'group',
    role_id: [1]
  }
  ];
